import * as React from 'react';
import * as moment from 'moment';
import { Link } from 'react-router-dom';

function createMarkup(html) {
    return {
        __html: html
    };
}

export const DocumentItem = ({ document }) => {
    const documentImage = document.image ? (<div className='image'>
        <img src={document.image} />
    </div>) : null;
    const documentBody = (<div className='content'>
        <div className='header'>{document.title}</div>
        <div className='meta'><span>{moment(document.date).format('Do MMMM YYYY')}</span></div>
        <div className='description' dangerouslySetInnerHTML={createMarkup(document.description)}></div>
    </div>);

    if (document.isEmbed) {
        if (document.embedFullScreen) {
            return (<a className='item' href={'/documents/fullscreen/' + document._id} target='_blank'>
                {documentImage}
                {documentBody}
            </a>);
        }
        else {
            const link = '/documents/' + document._id;

            return (<Link className='item' to={link}>
                {documentImage}
                {documentBody}
            </Link>);
        }
    }
    else {
        return (<a className='item' href={document.file_url} target='_blank'>
            {documentImage}
            {documentBody}
        </a>);
    }
}



// WEBPACK FOOTER //
// ./src/components/common/document/document-item.presentation.tsx